import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UI_ROUTES } from './helpers/routes';

import { HomeScreen } from './screens/HomeScreen';
import { VegasScreen } from './screens/VegasScreen';

const App: React.FC = () => {
  return (
    <div className='Container'>
      <Router>
        <Routes>
          <Route path={UI_ROUTES.Home} element={<VegasScreen />} />
          {/* <Route path={UI_ROUTES.Vegas} element={<VegasScreen />} /> */}
        </Routes>
      </Router>
    </div>
  )
}

export default App;
